import styled from 'styled-components';

import Dialog from 'components/dialog';
import Picture from 'components/picture';

export const StyledTitle = styled.h4`
  margin: 0 auto;
  font-family: ${Styles.fontFamily.alternative};
  font-size: 2.25rem;
`;

export const StyledDescription = styled.p`
  margin-block-start: 0.5rem;
  margin-block-end: 0;
  margin-inline: auto;
  font-family: ${Styles.fontFamily.body};
  font-size: 1rem;
`;

export const StyledDialog = styled(Dialog)`
  padding-block-start: 1.5rem;
  text-align: center;
  max-width: 24rem;
`;

export const StyledPicture = styled(Picture)`
  height: 12rem;
  width: 11rem;
  margin: auto;

  img {
    object-fit: contain;
  }
`;

export const StyledButtonGroup = styled.div`
  margin-block-start: 1.125rem;
  text-align: center;
  & button {
    width: 100%;
    margin-block-start: 1.125rem;
  }
`;
